module.exports = __webpack_public_path__ + "static/media/addRecipientGuide2.1633090c.png";